import { createFileRoute, Link } from "@tanstack/react-router"
import { IconPlusFill18 } from "nucleo-ui-fill-18"
import { z } from "zod"

import { PageHeader } from "@/components/common/page-header"
import { Button } from "@/components/ui/button"
import { OrganisationsList } from "@/features/admin/components/organisations-list"
import { adminOrganisationQueries } from "@/queries/admin-organisations"

const searchSchema = z.object({
  page: z.coerce.number().int().positive().optional(),
  perPage: z.coerce.number().int().positive().max(100).optional(),
  search: z.string().optional(),
})

export const Route = createFileRoute("/_authenticated/admin/organisations/")({
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData(adminOrganisationQueries.list(deps)),
  component: AdminOrganisationsPage,
})

function AdminOrganisationsPage() {
  const filters = Route.useSearch()

  return (
    <>
      <PageHeader
        title="Organisations"
        actions={
          <Button
            nativeButton={false}
            render={
              <Link to="/admin/organisations/create">
                <IconPlusFill18 data-icon="inline-start" />
                New organisation
              </Link>
            }
          />
        }
      />
      <OrganisationsList filters={filters} />
    </>
  )
}
